export const SET_EMPLOYEES_WORKOUT_WATCHTIME = "SET_EMPLOYEES_WORKOUT_WATCHTIME";
export const SET_NUMBER_OF_EMPLOYEES = "SET_NUMBER_OF_EMPLOYEES";
export const SET_TEAM_FAVORITE_WORKOUT = "SET_TEAM_FAVORITE_WORKOUT";
